import { cn } from '@/lib/shadcn/lib/utils';

export function Email({ className }: { className?: string }) {
  return (
    <svg
      className={cn('size-full', className)}
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M20.75 4.5H3.25C2.91848 4.5 2.60054 4.6317 2.36612 4.86612C2.1317 5.10054 2 5.41848 2 5.75V18.25C2 18.5815 2.1317 18.8995 2.36612 19.1339C2.60054 19.3683 2.91848 19.5 3.25 19.5H20.75C21.0815 19.5 21.3995 19.3683 21.6339 19.1339C21.8683 18.8995 22 18.5815 22 18.25V5.75C22 5.41848 21.8683 5.10054 21.6339 4.86612C21.3995 4.6317 21.0815 4.5 20.75 4.5ZM19.7875 18.25H4.2875L8.6625 13.725L7.7625 12.8563L3.25 17.525V6.7L11.0188 14.4312C11.253 14.6641 11.5698 14.7947 11.9 14.7947C12.2302 14.7947 12.547 14.6641 12.7812 14.4312L20.75 6.50625V17.4437L16.15 12.8438L15.2688 13.725L19.7875 18.25ZM4.06875 5.75H19.7375L11.9 13.5437L4.06875 5.75Z"
        fill="currentColor"
      />
    </svg>
  );
}
